module.exports = __webpack_public_path__ + "img/hand-thumbs-up.95f2ff42.svg";